<template>
    <div class="relative">
        <Toast :popstate="$page.props.popstate" :toast="$page.props.toast" />
        <div
            class="
                min-h-screen
                flex flex-col flex-auto flex-shrink-0
                antialiased
                bg-white
                text-black
            "
        >
            <!-- Header -->
            <div
                class="
                    fixed
                    w-full
                    flex
                    items-center
                    justify-between
                    h-14
                    text-white
                    z-10
                    bg-indigo-400
                "
            >
                <div
                    class="
                        flex
                        items-center
                        justify-start
                        md:justify-center
                        pl-3
                        w-14
                        md:w-64
                        h-14
                        border-none
                    "
                >
                    <span class="inline-flex rounded-md mr-2">
                        <button
                            type="button"
                            class="
                                bg-indigo-500
                                flex
                                text-sm
                                rounded-full
                                focus:outline-none
                                focus:ring-2
                                focus:ring-offset-2
                                focus:ring-offset-indigo-600
                                focus:ring-white
                            "
                            aria-expanded="false"
                            aria-haspopup="true"
                        >
                            <span class="sr-only">Open user menu</span>
                            <img
                                class="h-8 w-8 rounded-full"
                                :src="$page.props.auth.user.profile_photo_url"
                                alt=""
                            />
                        </button>
                    </span>
                    <span class="hidden md:block">ADMIN</span>
                </div>
                <div class="flex justify-end items-center h-14 header-right">
                    <inertia-link
                        as="button"
                        method="post"
                        :href="route('logout')"
                        class="
                            flex
                            focus:outline-none
                            items-center
                            mr-4
                            hover:text-blue-100
                        "
                    >
                        <span class="inline-flex mr-1">
                            <svg
                                class="w-5 h-5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                ></path>
                            </svg>
                        </span>
                        Logout
                    </inertia-link>
                </div>
            </div>
            <!-- ./Header -->

            <!-- Sidebar -->
            <div
                class="
                    fixed
                    flex flex-col
                    top-14
                    left-0
                    w-14
                    hover:w-64
                    md:w-64
                    bg-indigo-600
                    h-full
                    text-white
                    transition-all
                    duration-300
                    border-none
                    z-10
                    sidebar
                "
            >
                <div
                    class="
                        overflow-y-auto overflow-x-hidden
                        flex flex-col
                        justify-between
                        flex-grow
                    "
                >
                    <ul class="flex flex-col py-4 space-y-1">
                        <li class="px-5 hidden md:block">
                            <div class="flex flex-row items-center h-8">
                                <div
                                    class="
                                        text-sm
                                        font-light
                                        tracking-wide
                                        text-gray-300
                                        uppercase
                                    "
                                >
                                    Main
                                </div>
                            </div>
                        </li>
                        <li v-for="(item, index) in menuItems" :key="index">
                            <inertia-link
                                :href="route(`admin.${item.route}`)"
                                class="
                                    relative
                                    flex flex-row
                                    items-center
                                    h-11
                                    focus:outline-none
                                    hover:bg-blue-800
                                    text-white-600
                                    hover:text-white-800
                                    border-l-4 border-transparent
                                    hover:border-blue-500
                                    pr-6
                                "
                                :class="{
                                    'bg-blue-800 border-blue-500':
                                        route().current(`admin.${item.active}`),
                                }"
                            >
                                <span
                                    class="
                                        inline-flex
                                        justify-center
                                        items-center
                                        ml-4
                                    "
                                >
                                    <breeze-icons :name="item.icon" />
                                </span>
                                <span
                                    class="ml-2 text-sm tracking-wide truncate"
                                    >{{ item.text }}</span
                                >
                            </inertia-link>
                        </li>
                        <li class="px-5 hidden md:block">
                            <div class="flex flex-row items-center h-8">
                                <div
                                    class="
                                        text-sm
                                        font-light
                                        tracking-wide
                                        text-gray-300
                                        uppercase
                                    "
                                >
                                    Exercises
                                </div>
                            </div>
                        </li>
                        <li v-for="item in exercises" :key="item.id">
                            <inertia-link
                                :href="route(`admin.${item.slug}.index`)"
                                class="
                                    relative
                                    flex flex-row
                                    items-center
                                    h-11
                                    focus:outline-none
                                    hover:bg-blue-800
                                    text-white-600
                                    hover:text-white-800
                                    border-l-4 border-transparent
                                    hover:border-blue-500
                                    pr-6
                                "
                                :class="{
                                    'bg-blue-800 border-blue-500':
                                        route().current(
                                            `admin.${item.slug}.index`
                                        ),
                                }"
                            >
                                <span
                                    class="
                                        inline-flex
                                        justify-center
                                        items-center
                                        ml-4
                                    "
                                >
                                    <breeze-icons name="database" />
                                </span>
                                <span
                                    class="ml-2 text-sm tracking-wide truncate"
                                    >{{ item.title }}</span
                                >
                            </inertia-link>
                        </li>
                        <li class="px-5 hidden md:block">
                            <div class="flex flex-row items-center mt-5 h-8">
                                <div
                                    class="
                                        text-sm
                                        font-light
                                        tracking-wide
                                        text-gray-300
                                        uppercase
                                    "
                                >
                                    Settings
                                </div>
                            </div>
                        </li>
                        <li>
                            <inertia-link
                                :href="route('admin.user.profile')"
                                class="
                                    relative
                                    flex flex-row
                                    items-center
                                    h-11
                                    focus:outline-none
                                    hover:bg-blue-800
                                    text-white-600
                                    hover:text-white-800
                                    border-l-4 border-transparent
                                    hover:border-blue-500
                                    pr-6
                                "
                            >
                                <span
                                    class="
                                        inline-flex
                                        justify-center
                                        items-center
                                        ml-4
                                    "
                                >
                                    <svg
                                        class="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                        ></path>
                                    </svg>
                                </span>
                                <span
                                    class="ml-2 text-sm tracking-wide truncate"
                                    >Profile</span
                                >
                            </inertia-link>
                        </li>
                        <li>
                            <inertia-link
                                :href="route('admin.setting.index')"
                                class="
                                    relative
                                    flex flex-row
                                    items-center
                                    h-11
                                    focus:outline-none
                                    hover:bg-blue-800
                                    text-white-600
                                    hover:text-white-800
                                    border-l-4 border-transparent
                                    hover:border-blue-500
                                    pr-6
                                "
                            >
                                <span
                                    class="
                                        inline-flex
                                        justify-center
                                        items-center
                                        ml-4
                                    "
                                >
                                    <svg
                                        class="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                        ></path>
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                        ></path>
                                    </svg>
                                </span>
                                <span
                                    class="ml-2 text-sm tracking-wide truncate"
                                    >Settings</span
                                >
                            </inertia-link>
                        </li>
                    </ul>
                    <p
                        class="
                            mb-14
                            px-5
                            py-3
                            hidden
                            md:block
                            text-center text-xs
                        "
                    >
                        Copyright @{{ new Date().getFullYear() }}
                    </p>
                </div>
            </div>
            <!-- ./Sidebar -->

            <div class="h-full ml-14 mt-14 mb-10 md:ml-64">
                <!-- Page Heading -->
                <header class="bg-white shadow" v-if="$slots.header">
                    <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                        <slot name="header" />
                    </div>
                </header>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import BreezeIcons from "@/Components/Icons";
import Toast from "@/Components/Toast";
export default {
    components: {
        BreezeIcons,
        Toast,
    },
    data() {
        return {
            menuItems: [
                {
                    text: "Dashboard",
                    icon: "home",
                    route: "dashboard",
                    active: "dashboard",
                },
                {
                    text: "Plans",
                    icon: "list",
                    route: "plans.index",
                    active: "plans.*",
                },
                {
                    text: "Messages",
                    icon: "message",
                    route: "message.index",
                    active: "message.*",
                },
                {
                    text: "Categories",
                    icon: "list",
                    route: "category.index",
                    active: "category.*",
                },
                {
                    text: "Formats",
                    icon: "list",
                    route: "format.index",
                    active: "format.*",
                },
                {
                    text: "Score Comment",
                    icon: "comment",
                    route: "comment.index",
                    active: "comment.*",
                },
                {
                    text: "Dashboard Section",
                    icon: "home",
                    route: "user-dashboard.index",
                    active: "user-dashboard.*",
                },
                {
                    text: "Coaches",
                    icon: "users",
                    route: "user.coach",
                    active: "user.coach",
                },
                {
                    text: "Users",
                    icon: "users",
                    route: "user.users",
                    active: "user.users",
                },
            ],
            exercises: [],
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            axios
                .get(route("admin.init"))
                .then(({ data }) => {
                    this.exercises = data;
                })
                .catch((err) => console.log(err));
        },
    },
};
</script>
<style scoped>
/* Custom style */
.header-right {
    width: calc(100% - 3.5rem);
}
.sidebar:hover {
    width: 16rem;
}
@media only screen and (min-width: 768px) {
    .header-right {
        width: calc(100% - 16rem);
    }
}
</style>
